export default "__VITE_ASSET__CXn$xGIA__"